import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import HistoryComponent from '../components/HistoryComponent.js'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    history: state.history.today,
    currentDates: state.settings.currentDates
  }
}

export default connect(mapStateToProps, mapActionCreators)(HistoryComponent)



// WEBPACK FOOTER //
// ./src/routes/History/containers/HistoryContainer.js